import { Component, Input } from '@angular/core';
import { IAddress, emptyAddress } from '@nx-ng/types';

@Component({
  selector: 'nx-ng-address-test',
  template: `<form #testForm="ngForm">
    <nx-ng-address [address]="address" [readonly]="readonly"> </nx-ng-address>
  </form>`,
})
export class AddressTestComponent {
  @Input()
  address: IAddress = emptyAddress;

  @Input()
  readonly = false;
}
